const initialState = '';

const strapiToken = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_STRAPI_TOKEN': {
            return action.payload;
        }

        default: {
            return state;
        }
    }
};

export default strapiToken;
